// Readable action names for the Activity table (DataModel's catalog, D-58). Our wording: UserFlows is silent.
const LABELS: Record<string, string> = {
  'clinic.create': 'Clinic created',
  'clinic.update': 'Clinic edited',
  'clinic.deactivate': 'Clinic deactivated',
  'clinic.reactivate': 'Clinic reactivated',
  'connection.update': 'Connection changed',
  'connection.test': 'Connection tested',
  'user.create': 'User created',
  'user.reset_password': 'Password reset',
  'user.password_changed': 'Password set',
  'user.disable': 'User disabled',
  'super_admin.bootstrap': 'Super admin created',
  'super_admin.revoke': 'Super admin removed',
  'membership.create': 'User added',
  'membership.role_change': 'Role changed',
  'membership.remove': 'User removed',
  'settings.update': 'Settings saved',
  'settings.refresh_from_pf': 'Refreshed from PF',
  'settings.catalog_flagged': 'PF change flagged',
  'protection.update': 'Protection changed',
  'source.add': 'Source added',
  'source.remove': 'Source removed',
  'impersonation.start': 'Impersonation started',
  'impersonation.end': 'Impersonation ended',
  'errors.delete': 'Errors deleted',
  'security.unblock': 'Block lifted',
}

export const actionLabel = (action: string): string => LABELS[action] ?? action
